export default function (data) {
  let status;
  if (data.bomSubmissionStatus == undefined) {
    return '';
  }

  let submitDate,
    popoverDataArr = [],
    popoverHtml = '';

  if (data.bomSubmitInformations && data.bomSubmitInformations.length) {
    const infoArray = data.bomSubmitInformations;
    submitDate = moment(infoArray[infoArray.length - 1].createDate).format('MMM DD, YYYY HH:mm');

    infoArray.forEach((data) => {
      let title;
      if (data.isSuccess) {
        title = `<span class='ml-n3 status-label text-success'><i class="far fa-fw fa-vote-yea mr-1"></i>${$Lang.BOM.BOMSubmitted}</span>`;
      } else {
        title = `<span class='ml-n3 status-label text-danger'><i class="far fa-fw fa-exclamation-circle mr-1"></i>${$Lang.BOM.BOMsubmissionfailed}</span>`;
      }

      popoverDataArr.push(`<div class='d-flex flex-column mb-2'>
          ${title}
          <div class="pl-3">
            <p class="my-1">${moment(data.createDate).format('MMM DD, YYYY HH:mm')}</p>
            ${
              data.details
                ? `<p class="mb-0">Colors: ${data.details.colorsCount}, Sizes: ${data.details.sizesCount}</p>`
                : ``
            }
            ${data.message ? `<p class="mb-0">${data.message}</p>` : ``}
          </div>
        </div>`);
    });
  }

  if (popoverDataArr.length) {
    let content = `<div class='d-flex flex-column pl-2'>${popoverDataArr.join('')}</div>`;
    popoverHtml = `<a href="javascript:" 
                    data-content="${content.replaceAll('"', '&quot;')}" 
                    data-html="true" 
                    data-trigger="hover" 
                    data-placement="top" 
                    data-toggle="popover" class="ml-1"><i class="fal fa-info-circle fa-lg"></i></a>`;
  }

  switch (data.bomSubmissionStatus) {
    case 1:
      status = 'inprocess';
      break;
    case 2:
      status = 'submited';
      break;
    case 3:
      status = 'failed';
      break;
    default:
      status = 'notsubmited';
      break;
  }
  return `<span class="bom-status bom-${status}">
          <span class="bom-status-inprocess status-label text-warning mr-n4" data-aid="status-warning"><i class="far fa-fw fa-sync-alt mr-1"></i>${
            $Lang.BOM.BOMinprocess
          }</span>
          <span class="bom-status-submited status-label text-success mr-n4" data-aid="status-success"><i class="far fa-fw fa-vote-yea mr-1"></i>${
            $Lang.BOM.BOMSubmitted
          }</span>
          <span class="bom-status-failed status-label text-danger mr-n4" data-aid="status-danger"><i class="far fa-fw fa-exclamation-circle mr-1"></i>${
            $Lang.BOM.BOMsubmissionfailed
          }</span>
          <span class="bom-status-notsubmited status-label text-muted mr-n4" data-aid="status-muted"><i class="far fa-fw fa-vote-nay mr-1"></i>${
            $Lang.BOM.BOMnotSubmitted
          }</span>
          <span class="d-inline-flex ml-4 pl-2">
            <span class="bom-status-date">${submitDate ? submitDate : ''}</span>
            ${popoverHtml}
          </span>
          </span>`;
}
